"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
/**
 * Allows for chained calls to build subscription filters as a fluent interface.
 *
 * @class SubscriptionBuilder<T>
 */
class SubscriptionBuilder {
    constructor(params) {
        this.params = params;
        this.resources = [];
    }
    /**
     * Appends a resource to subscription filter
     *
     * @param resource
     */
    appendResource(resource) {
        this.resources.push(resource);
        return this;
    }
    /**
     * Finishes the subscription.
     *
     * @param {Transport} params.transport channel to deliver the notifications on
     * @param {string} params.methodFilter optional method filter
     */
    endSubscribe(params) {
        return this.params.complete(Object.assign(Object.assign({}, params), { subjectFilter: this.createSubjectFilter() }));
    }
    createSubjectFilter() {
        const subjectFilter = this.resources.map(resource => {
            if (resource.target === '') {
                return `${resource.type}`;
            }
            else {
                const target = !resource.escapeTarget ? resource.target : _.escapeRegExp(resource.target);
                return `${resource.type}/${(target || '[^/]+')}`;
            }
        }).join('/');
        return `/${subjectFilter}$`;
    }
}
exports.SubscriptionBuilder = SubscriptionBuilder;
//# sourceMappingURL=subscription-builder.js.map